import DOMComponentRegistry from "../util/DOMComponentRegistry";
import {fixKeyboardEvent} from "./keyboard";

class OverlayComponentRegistry extends DOMComponentRegistry {
  initializeOne(labelSelector) {
    let label = document.querySelector(labelSelector);
    let checkbox = document.querySelector("#" + label.htmlFor);

    if (checkbox === null || label === null) {
      return;
    }

    this.registerKeyEvents(checkbox);

    checkbox.addEventListener("change", event => {
      //event.preventDefault();
      let doEnable = checkbox.checked;
      this.disableAll();
      if (doEnable) {
        label.classList.add("js-active");
        document.body.classList.add("overflow-hidden");
      }
      this.registerKeyEvents(checkbox, label);
    })
  }

  disableAll() {
    let labels = Array.from(document.querySelectorAll(".js-active"));
    labels.forEach(label => {
        let checkbox = document.querySelector("#" + label.htmlFor);
        checkbox.checked = false;
        label.classList.remove("js-active");
    });

    document.body.classList.remove("overflow-hidden");
  }

  registerKeyEvents(checkbox, label) {
    if (checkbox.checked) {
      window.addEventListener("keydown", this.handleEscape.bind(this, checkbox, label));
    }
    else {
      window.removeEventListener("keydown", this.handleEscape.bind(this, checkbox, label));
    }
  }

  handleEscape(checkbox, label, event) {
    event = fixKeyboardEvent(event);

    if (event.key !== "Escape") {
      return;
    }

    checkbox.checked = false;
    label.classList.remove("js-active");
    document.body.classList.remove("overflow-hidden");

    this.registerKeyEvents(checkbox, label);
  }
}

export default new OverlayComponentRegistry();
